module.exports = __webpack_public_path__ + "static/media/welcome_page_full.36e64572.png";